"use client";

import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Separator } from "@/components/ui/separator";
function FooterMenuColumn({
  menu_id
}: {
  menu_id: string;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-4 w-24 bg-primary-light/20 animate-pulse rounded-sm" />
        <div className="h-4 w-20 bg-primary-light/20 animate-pulse rounded-sm" />
        <div className="h-4 w-28 bg-primary-light/20 animate-pulse rounded-sm" />
      </div>;
  }
  return <NavigationMenu viewport={false} className="flex-col items-start">
      <NavigationMenuList className="flex-col items-start gap-3">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-primary-light/80 hover:text-accent transition-all duration-[var(--duration-fast)] font-sans text-sm font-normal">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }];
  return <footer id="footer" className="bg-dark-background text-primary-light py-16">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="flex flex-col gap-6" data-index={0}>
            <img src="https://globalwholesaletrade.com/wp-content/uploads/2026/02/GWTlogo002-Transparent_White_color_with_brillinantlime.png" alt="Global Wholesale Trade" className="!p-0 !rounded-none !w-[120px] !h-[120px]" />
          </div>

          <MenuProvider menu_id="32" data-index={1}>
            <FooterMenuColumn menu_id="32" />
          </MenuProvider>

          <div className="flex flex-col gap-6" data-index={2}>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} newTab aria-label={social.label} data-index={i} className="w-10 h-10 rounded-sm bg-primary-light/10 hover:bg-accent flex items-center justify-center transition-all duration-[var(--duration-fast)] group">
                    <Icon className="size-5 text-primary-light group-hover:text-white transition-colors duration-[var(--duration-fast)]" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="bg-accent/30 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-primary-light/60 text-sm font-sans">
            © {new Date().getFullYear()} Global Wholesale Trade. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}